import DataObjectField from '@/utilities/classes/data-object-field';

const buildLedgerDataObject = (rentAmountOwed, paymentDueDate, paymentMonth, paymentYear, rentAmountPaid, totalAmountOwed, feesOwed, feeAmountPaid, feeType, feesOwed2, feeAmountPaid2, feeType2, feesOwed3, feeAmountPaid3, feeType3, feesOwed4, feeAmountPaid4, feeType4, feesOwed5, feeAmountPaid5, feeType5, feesOwed6, feeAmountPaid6, feeType6, applicantId, LandlordRecordID) => {
  const fields = [
    new DataObjectField(rentAmountOwed, 7),
    new DataObjectField(paymentDueDate, 6),
    new DataObjectField(rentAmountPaid, 15),
    new DataObjectField(totalAmountOwed, 17),
    new DataObjectField(applicantId, 14),
    new DataObjectField(paymentMonth, 19),
    new DataObjectField(paymentYear, 20),
    new DataObjectField(feesOwed, 16),
    new DataObjectField(feeAmountPaid, 21),
    new DataObjectField(feeType, 22),
    new DataObjectField(feesOwed2, 24),
    new DataObjectField(feeAmountPaid2, 25),
    new DataObjectField(feeType2, 26),
    new DataObjectField(feesOwed3, 27),
    new DataObjectField(feeAmountPaid3, 28),
    new DataObjectField(feeType3, 29),
    new DataObjectField(feesOwed4, 30),
    new DataObjectField(feeAmountPaid4, 31),
    new DataObjectField(feeType4, 32),
    new DataObjectField(feesOwed5, 33),
    new DataObjectField(feeAmountPaid5, 34),
    new DataObjectField(feeType5, 35),
    new DataObjectField(feesOwed6, 36),
    new DataObjectField(feeAmountPaid6, 37),
    new DataObjectField(feeType6, 38),
    new DataObjectField(LandlordRecordID, 39),
  ];
  const dataObject = {
    qdbapi: {
      udata: "EVICTION_DIVERSION_TFA_LEDGER_ENTRY",
      field: fields,
    },
  };
  return dataObject;
};
export default buildLedgerDataObject;
